var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("span", [_vm._v("服务器：")]),
      _c(
        "el-select",
        {
          attrs: { placeholder: "选择环境" },
          on: { change: _vm.handleChangle },
          model: {
            value: _vm.host,
            callback: function($$v) {
              _vm.host = $$v
            },
            expression: "host"
          }
        },
        _vm._l(_vm.options, function(item) {
          return _c("el-option", {
            key: item.value,
            attrs: { label: item.label, value: item.value }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }